var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardLogoMaestro = function SvgCardLogoMaestro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 39,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 37.5,
    x: 0.5,
    y: 0.5,
    fill: "#F9F9FA",
    rx: 5.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 37.5,
    x: 0.5,
    y: 0.5,
    stroke: "#DFE0E5",
    rx: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    d: "M20.8 8.02c6.03 0 10.918 4.817 10.918 10.757 0 5.941-4.888 10.758-10.918 10.758S9.882 24.718 9.882 18.777 14.771 8.021 20.8 8.021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0099DF",
    d: "M34.964 8.02c6.03 0 10.918 4.817 10.918 10.757 0 5.941-4.888 10.758-10.918 10.758s-10.918-4.817-10.918-10.758S28.935 8.021 34.964 8.021"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6BBD",
    d: "M27.882 10.594c2.347 1.973 3.836 4.906 3.836 8.184s-1.49 6.21-3.836 8.183c-2.346-1.973-3.836-4.906-3.836-8.183s1.49-6.21 3.836-8.184"
  })));
};
export default SvgCardLogoMaestro;